import ProfileInformation from "../Settings/ProfileInformation";

export const BrandProfile = () => {
	return <ProfileInformation />;
};
